import { MultiLevelCategory, ProductBaseInfo } from '@shopby/shop-sdk'
import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import 'swiper/css'
import 'swiper/css/free-mode'
import { FreeMode } from 'swiper/modules'
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react'
import { SectionDetailType } from '../../@types/home'
import { getSectionsDetail, getSortCategoryHomeSearch } from '../../api/home'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { BtnHomeModuleMore } from '../Button'
import CommonCarousel from '../CommonCarousel'
import ProductCenterModal from '../product/ProductCenterModal'
import ProductModal from '../product/ProductModal'
import { useAppContext } from '../provider/AppProvider'
import RankingCategoryItem from './RankingCategoryItem'

const CategoryRanking = ({ el, index, category }: any) => {
  const [sectionItem, setSectionItem] = useState<SectionDetailType[]>() //섹션정보
  const [categoryItem, setCategoryItem] = useState<MultiLevelCategory[]>([]) //카테고리
  const [selectCategory, setSelectCategory] = useState<MultiLevelCategory | null>(null) //선택된 카테고리
  const [item, setItem] = useState<ProductBaseInfo[]>([]) // 진열하고자하는 상품
  const [isModal, setIsModal] = useState<boolean>(false)
  const [selectProductNo, setSelectProductNo] = useState<string>() // 선택된 상품 넘버
  const [isTouchMoving, setIsTouchMoving] = useState<boolean>(false)
  const { isAppView } = useAppContext()

  const navigate = useNavigate()

  //상품진열 상세
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getSectionsDetail(el.sectionNo)
        setSectionItem(res.data)
      } catch (err) {
        console.log(err)
      }
    }

    fetchData()
  }, [el.sectionNo])

  //낚시용품만 거르기
  useEffect(() => {
    if (category) {
      const fishingCategory = category.multiLevelCategories.filter((el: MultiLevelCategory) => el.label === '낚시용품')
      if (fishingCategory.length > 0) {
        setCategoryItem(fishingCategory[0].children)
        setSelectCategory(fishingCategory[0].children[0])
      }
    }
  }, [category])

  //상품 많이 팔리는 순서 정렬
  useEffect(() => {
    const fetchSortedItems = async () => {
      if (selectCategory !== null && selectCategory.categoryNo !== undefined) {
        try {
          const res = await getSortCategoryHomeSearch('SALE_CNT', 1, selectCategory.categoryNo, 'DESC')
          setItem(res.data.items)
        } catch (error) {
          console.error('Error fetching sorted items:', error)
        }
      }
    }

    fetchSortedItems()
  }, [selectCategory])

  const touchMove = useCallback(() => {
    setIsTouchMoving(true)
  }, [])

  const touchEnd = useCallback(() => {
    setIsTouchMoving(false)
  }, [])

  const handleTouchEnd = useCallback(
    (categoryNo: any) => {
      if (!isTouchMoving) {
        setSelectCategory(categoryNo)
      }
    },
    [isTouchMoving]
  )

  const swiperProps: SwiperProps = useMemo(
    () => ({
      spaceBetween: 4,
      slidesPerView: 'auto',
      breakpoints: {
        768: {
          spaceBetween: 8,
        },
      },
      modules: [FreeMode],
      freeMode: false,
      centeredSlidesBounds: true,
      slideToClickedSlide: true,
      onTouchMove: touchMove,
      onTouchEnd: touchEnd,
    }),
    [touchMove, touchEnd]
  )

  const navigateClickHandler = useCallback(() => {
    const gtmNavigateClick: DataLayerArgs = {
      dataLayer: {
        event: 'select_content',
        event_info: {
          content_type: '홈모듈',
          content_id: String(el.sectionNo),
          content_name: el.sectionName,
        },
      },
    }
    if (isAppView) {
      sendSetAppsflyerEvent({
        eventName: 'select_content',
        eventType: {
          content_type: '홈모듈',
          content_id: String(el.sectionNo),
          content_name: el.sectionName,
        },
      })
    } else {
      TagManager.dataLayer(gtmNavigateClick)
    }
  }, [el.sectionNo, el.sectionName, isAppView])

  const moreClickHandler = useCallback(() => {
    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/category/${selectCategory?.categoryNo}/${selectCategory?.categoryNo}/${selectCategory?.categoryNo}`,
      })
    } else {
      navigate(`/category/${selectCategory?.categoryNo}/${selectCategory?.categoryNo}/${selectCategory?.categoryNo}`)
    }
  }, [navigate, selectCategory])

  const memoizedItems = useMemo(() => item, [item])
  const memoizedSelectCategory = useMemo(() => selectCategory, [selectCategory])

  return (
    <>
      <div className='best_ranking' onClick={navigateClickHandler} style={{ minHeight: isMobile ? '450px' : '734px' }}>
        <div className='home_module_title'>
          <p>{sectionItem ? sectionItem[0]?.promotionText : ''}</p>
          <p>
            <strong>{sectionItem ? sectionItem[0]?.sectionExplain : ''}</strong>
          </p>
        </div>
        <div className='tab_wrap'>
          <div className='tab_swiper_wrap'>
            <CommonCarousel
              swiperProps={swiperProps}
              items={categoryItem}
              CustomRenderItem={SwiperSlideItem}
              renderItem={(item: any) => (
                <div
                  className={selectCategory?.categoryNo === item?.categoryNo ? 'on' : ''}
                  onTouchEnd={() => {
                    if (isMobile) handleTouchEnd(item)
                  }}
                  onClick={(): void => {
                    if (!isMobile) setSelectCategory(item)
                  }}
                  key={item.categoryNo}
                >
                  <button>{item.label}</button>
                </div>
              )}
            />
          </div>
        </div>
        <div className='best_ranking_list'>
          <ul>
            {memoizedItems.map((item: any, idx: number) => (
              <RankingCategoryItem
                el={item}
                idx={idx}
                isAppView={isAppView}
                setIsModal={setIsModal}
                setSelectProductNo={setSelectProductNo}
                key={idx}
                listId={el.sectionNo}
                listName={el.sectionName}
                selectCategory={memoizedSelectCategory}
              />
            ))}
          </ul>
        </div>
        {memoizedItems && (
          <div className='btn_more_wrap'>
            <BtnHomeModuleMore onClick={moreClickHandler}>더보기</BtnHomeModuleMore>
          </div>
        )}
        {index !== 0 && <hr />}
      </div>
      {isModal &&
        (isMobile ? (
          <ProductModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={item}
            listId={el.sectionNo}
            listName={el.sectionName}
          />
        ) : (
          <ProductCenterModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={item}
            listId={el.sectionNo}
            listName={el.sectionName}
          />
        ))}
    </>
  )
}

export default memo(CategoryRanking)

export const SwiperWrap = styled(Swiper)`
  padding: 0 18px;
  @media screen and (min-width: 768px) {
    padding: 0;
  }
`
export const SwiperSlideItem = styled(SwiperSlide)`
  width: auto !important;
  & .on {
    & button {
      color: var(--colWhite);
      background: var(--colBlack);
      border: 1px transparent solid;
    }
  }
  & button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--colGray76);
    background: var(--colWhite);
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    word-break: keep-all;
    height: 32px;
    border-radius: 32px;
    border: 1px var(--colGray3) solid;
    padding: 8px 14px;
    white-space: nowrap;
  }
  @media screen and (min-width: 768px) {
    & .on {
      & button {
        color: var(--colWhite);
        background: var(--colBlack);
        border: 1px transparent solid;
      }
    }
    & button {
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--colGray6);
      background: var(--colWhite);
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      word-break: keep-all;
      height: 40px;
      border-radius: 32px;
      border: 1px var(--colGray3) solid;
      padding: 10px 16px;
      white-space: nowrap;
    }
  }
`
